<template>
  <div class="separation-of-funds">
    <proposal-PO-info
      v-if="isDeliveredForObligation"
      :details="proposalRequestInfo"
    />
    <section-title
      class="mt-4 mb-3"
      has-line
      title="Asignación de Fondos"
      title-class="section-title-info"
    />

    <div v-if="tabModes.viewMode === state">
      <div v-for="(separationFund, index) in separationFunds" :key="index">
        <separation-fund-row
          :key="separationFund.separationFundNumber"
          :is-contract-signed="isContractSigned"
          :proposal-request-id="
            proposalRequestId ?? separationFund.proposalRequestId
          "
          :proposal-status-id="proposalRequestInfo?.proposalRequestStatus?.id"
          :value="separationFund"
          @on-edit="handleEdit"
        />
      </div>
    </div>

    <div
      v-if="
        tabModes.addingState != state &&
          tabModes.editMode != state &&
          separationFunds.length > 0 &&
          canAddSeparationFunds
      "
      class="row justify-content-end p-3"
    >
      <action-button
        i="fas fa-file-plus"
        text=" Añadir"
        variant="success"
        @click="changeState(tabModes.addingState)"
      />
    </div>

    <div v-if="tabModes.addingState === state" class="px-3 py-2">
      <validation-observer ref="separationOfFunds">
        <div class="row mx-auto">
          <div class="col-12 col-md-3 p-0 mr-md-4">
            <div class="label mb-2">Contratación:</div>
            <validation-provider v-slot="{ errors }" rules="required">
              <custom-drop-down
                :id="`reason`"
                v-model="record.contractType"
                custom-error-msg="La contratación es requerida."
                :disabled="true"
                :error="errors[0]"
                fieldkey="id"
                fieldname="name"
                :options="contractTypes"
                placeholder="Seleccione"
              />
            </validation-provider>
          </div>
          <div class="col-12 col-md-2">
            <div class="label mb-2">Fecha de Separación:</div>
            <validation-provider v-slot="{ errors }" rules="required">
              <custom-date-picker
                v-model="record.date"
                class="col-12 p-0"
                custom-error-msg="La fecha de separación es requerida."
                :error="errors[0]"
                placeholder="DD/MM/YYYY"
              />
            </validation-provider>
          </div>
          <div class="col-12 col-md-2">
            <div class="label mb-2">Fecha Hasta:</div>
            <validation-provider v-slot="{ errors }" rules="required">
              <custom-date-picker
                v-model="record.contractDateTo"
                class="col-12 p-0"
                :clearable="false"
                custom-error-msg="La fecha hasta es requerida."
                :error="errors[0]"
                :max-date="academicYear.toDate"
                :min-date="academicYear.fromDate"
                placeholder="DD/MM/YYYY"
              />
            </validation-provider>
          </div>
        </div>
        <div class="row mx-auto">
          <div class="col-12 p-0 mr-md-4">
            <validation-provider v-slot="{ errors }" rules="required">
              <custom-text-area
                v-model="record.justification"
                class="col-12 p-0"
                custom-error-msg="La justificación es requerida."
                :error="errors[0]"
                label="Nombre de justificación:"
                :maxlength="3000"
                placeholder="Escriba una Justificación"
                show-char-count
              />
            </validation-provider>
          </div>
        </div>

        <section-title
          class="mt-4 mb-3"
          has-line
          title="Cifra de Cuentas"
          title-class="section-title-info"
        />

        <div v-if="addingCifras" class="px-3">
          <account-number
            v-for="accountNumber of accountNumbersSelected"
            :key="`accountNumber-${accountNumber.purchaseOrderNumberId}`"
            :billing-service-categories="billingServiceCategories"
            class="mb-3"
            :is-read-only="true"
            :value="accountNumber"
            @remove="removeAccountNumber"
          />
          <account-number
            v-if="addingAccountNumbersMore"
            :account-numbers="accountNumbersUnSelected"
            :billing-service-categories="billingServiceCategories"
            :can-remove="accountNumbersSelected.length > 0"
            class="mb-4"
            :date-from="null"
            :date-to="record.contractDateTo"
            :required="accountNumbersSelected.length == 0"
            @add="addAccountNumber"
            @cancel="cancelAddingAccountNumber"
          />
        </div>

        <div
          v-if="
            !addingCifras ||
              (!addingAccountNumbersMore &&
                accountNumbersSelected.length > 0 &&
                accountNumbersUnSelected.length > 0)
          "
          class="d-flex justify-content-end"
        >
          <action-button
            v-if="separationFunds.length > 0"
            i="fa fa-times-circle"
            text="Cancelar"
            variant="outline-danger mr-3"
            @click="handleCancel"
          />
          <action-button
            i="fas fa-file-plus"
            text="Añadir Cifra de Cuentas"
            variant="success"
            @click="showAddingCifras()"
          />
          <action-button
            v-if="ownSave && accountNumbersSelected.length > 0"
            i="fas fa-save"
            text="Guardar"
            variant="success ml-3"
            @click="saveHandler()"
          />
        </div>
      </validation-observer>
    </div>

    <div
      v-if="tabModes.editMode === state && currentEditFund"
      class="px-3 py-2"
    >
      <validation-observer ref="separationOfFunds">
        <div class="row mx-auto">
          <div class="col-12 col-md-3 p-0 mr-md-4">
            <div class="label mb-2">Contratación:</div>
            <validation-provider v-slot="{ errors }" rules="required">
              <custom-drop-down
                :id="`reason`"
                v-model="currentEditFund.contractType"
                custom-error-msg="La contratación es requerida."
                :disabled="true"
                :error="errors[0]"
                fieldkey="id"
                fieldname="name"
                :options="contractTypes"
                placeholder="Seleccione"
              />
            </validation-provider>
          </div>
          <div class="col-12 col-md-2">
            <div class="label mb-2">Fecha de Separación:</div>
            <validation-provider v-slot="{ errors }" rules="required">
              <custom-date-picker
                v-model="currentEditFund.date"
                class="col-12 p-0"
                custom-error-msg="La fecha de separación es requerida."
                :error="errors[0]"
                placeholder="DD/MM/YYYY"
              />
            </validation-provider>
          </div>
          <div class="col-12 col-md-2">
            <div class="label mb-2">Fecha Hasta:</div>
            <validation-provider v-slot="{ errors }" rules="required">
              <custom-date-picker
                v-model="currentEditFund.contractDateTo"
                class="col-12 p-0"
                :clearable="false"
                custom-error-msg="La fecha hasta es requerida."
                :error="errors[0]"
                :max-date="academicYear.toDate"
                :min-date="academicYear.fromDate"
                placeholder="DD/MM/YYYY"
              />
            </validation-provider>
          </div>
        </div>
        <div class="row mx-auto">
          <div class="col-12 p-0 mr-md-4">
            <validation-provider v-slot="{ errors }" rules="required">
              <custom-text-area
                v-model="currentEditFund.justification"
                class="col-12 p-0"
                custom-error-msg="La justificación es requerida."
                :error="errors[0]"
                label="Nombre de justificación:"
                :maxlength="3000"
                placeholder="Escriba una Justificación"
                show-char-count
              />
            </validation-provider>
          </div>
        </div>

        <section-title
          class="mt-4 mb-3"
          has-line
          title="Cifra de Cuentas"
          title-class="section-title-info"
        />

        <div class="px-3">
          <account-number
            v-for="accountNumber of currentEditFund.accountNumbers"
            :key="`accountNumber-${accountNumber.purchaseOrderNumberId}`"
            :billing-service-categories="billingServiceCategories"
            class="mb-3"
            :is-read-only="true"
            :value="accountNumber"
            @remove="removeAccountNumber"
          />
          <account-number
            v-if="addingAccountNumbersMore"
            :account-numbers="accountNumbersUnSelected"
            :billing-service-categories="billingServiceCategories"
            :can-remove="accountNumbersSelected.length > 0"
            class="mb-4"
            :date-from="null"
            :date-to="currentEditFund.contractDateTo"
            :required="accountNumbersSelected.length == 0"
            @add="addAccountNumber"
            @cancel="cancelAddingAccountNumber"
          />
        </div>

        <div
          v-if="
            !addingCifras ||
              (!addingAccountNumbersMore &&
                accountNumbersSelected.length > 0 &&
                accountNumbersUnSelected.length > 0)
          "
          class="d-flex justify-content-end"
        >
          <action-button
            v-if="separationFunds.length > 0"
            i="fa fa-times-circle"
            text="Cancelar"
            variant="outline-danger mr-3"
            @click="handleCancel"
          />
          <action-button
            i="fas fa-file-plus"
            text="Añadir Cifra de Cuentas"
            variant="success"
            @click="showAddingCifras(true)"
          />
          <action-button
            v-if="ownSave && accountNumbersSelected.length > 0"
            i="fas fa-save"
            text="Guardar"
            variant="success ml-3"
            @click="saveHandler()"
          />
        </div>
      </validation-observer>
    </div>
  </div>
</template>

<script>
import SectionTitle from 'SectionTitle';
import CustomDatePicker from 'custom-date-picker';
import CustomDropDown from 'custom-drop-down';
import AccountNumber from '@/views/provider/proposalHistory/components/AccountNumberV2.vue';
import rejectArray from 'lodash/reject';
import alertMixin from 'utils/mixins/alert.mixin';
import SeparationFundRow from '@/views/provider/proposalHistory/components/SeparationFundRow.vue';
import CustomTextArea from 'CustomTextArea';
import ActionButton from 'ActionButton';
import proposalStatus from '@/utils/shared/constants/proposalStatus';
import ProposalPOInfo from '@/views/provider/proposalHistory/components/ProposalPoInfo.vue';

import {
  getFiltersForSeparationFunds,
  saveSeparationFund,
  editSeparationFund,
  getSeparationFunds,
} from '@/modules/serviceProposalHistory/api';
import { getBillingServiceCategories as _getBillingServiceCategories } from '@/modules/shared/provideraccountnumber.api.js';

const tabModes = Object.freeze({
  emptyState: 1,
  addingState: 2,
  viewMode: 3,
  editMode: 4,
});

const initialModel = {
  contractType: { name: 'Servicios Profesionales', contractTypeId: 1 },
  date: null,
  contractDateTo: null,
  justification:
    'Para proveer servicios relacionados de evaluación y terapias a estudiantes de educación especial de acuerdo con las reglamentaciones estatales y federales.',
};

export default {
  name: 'SeparationOfFundsTabV2',
  components: {
    SectionTitle,
    CustomDatePicker,
    CustomDropDown,
    AccountNumber,
    SeparationFundRow,
    CustomTextArea,
    ActionButton,
    ProposalPOInfo,
  },
  mixins: [alertMixin],
  props: {
    proposalRequestId: {
      type: Number,
      default: () => null,
    },
    proposalRequestInfo: {
      type: Object,
      default: () => {},
    },
    contractId: {
      type: Number,
      default: () => null,
    },
    readOnly: {
      type: Boolean,
      default: () => false,
    },
    fiscalYearId: {
      type: Number,
      default: () => null,
    },
    ownSave: {
      type: Boolean,
      default: () => false,
    },
    isContractSigned: {
      type: Boolean,
      default: () => false,
    },
    isAmendment: {
      type: Boolean,
      default: () => false,
    },
  },
  data: () => ({
    state: tabModes.emptyState,
    tabModes,
    record: { ...initialModel },
    academicYear: {},
    accountNumbers: [],
    contractTypes: [],
    accountNumbersSelected: [],
    separationFunds: [],
    addingCifras: false,
    addingAccountNumbersMore: false,
    billingServiceCategories: [],
    currentEditFund: null,
    originalFund: null,
  }),
  computed: {
    canAddSeparationFunds() {
      return this.userHasPermissions('provider.contract.separationFunds.add');
    },
    accountNumbersUnSelected() {
      const accountNumbersSelected = this.accountNumbersSelected.map(
        (x) => x.purchaseOrderNumberId
      );
      return rejectArray(this.accountNumbers, (x) =>
        accountNumbersSelected.includes(x.purchaseOrderNumberId)
      );
    },
    isDeliveredForObligation() {
      return (
        this.proposalRequestInfo?.proposalRequestStatus?.id ==
        proposalStatus.DeliveredForObligation
      );
    },
  },
  watch: {
    contractId() {
      this.initSeparation();
    },
  },
  async mounted() {
    await this.initSeparation();
    await this.initFiltersForSeparationFunds();
  },
  methods: {
    handleCancel() {
      if (this.state === this.tabModes.editMode) {
        Object.assign(this.currentEditFund, this.originalFund);
        this.originalFund = null;
        this.currentEditFund = null;
      }
      this.changeState(tabModes.viewMode);
    },
    handleEdit(fund) {
      this.currentEditFund = this.separationFunds.find(
        (x) => x.separationFundNumber === fund
      );
      this.currentEditFund.contractType = {
        name: this.currentEditFund.contractTypeName,
        contractTypeId: this.currentEditFund.contractTypeId,
      };
      this.originalFund = { ...this.currentEditFund };
      this.originalFund.accountNumbers = [
        ...this.currentEditFund.accountNumbers,
      ];
      this.changeState(tabModes.editMode);
    },
    async changeState(state) {
      this.state = Number(state);

      if (this.state === this.tabModes.viewMode) {
        this.addingCifras = false;
        this.addingAccountNumbersMore = false;
        this.accountNumbersSelected = [];
      }
    },
    async initSeparation() {
      if (!this.contractId && !this.proposalRequestId) return;

      await getSeparationFunds({
        proposalRequestId: this.proposalRequestId,
        contractId: this.contractId,
      })
        .then((res) => {
          const data = !this.isAmendment
            ? res.data.filter((x) => x.contractId === null)
            : res.data.filter((x) => x.contractId == this.contractId);
          if (data.length === 0 && this.canAddSeparationFunds) {
            this.changeState(tabModes.addingState);
          } else {
            this.separationFunds = [...data];
            this.changeState(tabModes.viewMode);
          }
        })
        .catch((err) => {
          if (err.response != null)
            this.ShowToast(
              'Alerta',
              err.response.data.message || 'error',
              'error',
              5000
            );
        });
    },
    async initFiltersForSeparationFunds() {
      if (!this.contractId && !this.proposalRequestId) return;

      await getFiltersForSeparationFunds({
        proposalRequestId: this.proposalRequestId,
        contractId: this.contractId,
      }).then((res) => {
        const {
          academicYear,
          accountNumber,
          contractType,
          defaultJustification,
        } = res.data;

        this.academicYear = { ...academicYear };
        this.accountNumbers = [...accountNumber];
        this.contractTypes = [...contractType];
        this.record.justification = defaultJustification;
      });

      const { data } = await _getBillingServiceCategories();

      this.billingServiceCategories = data;
    },
    addAccountNumber(accountNumber) {
      if (this.state === this.tabModes.editMode) {
        this.currentEditFund.accountNumbers.push(accountNumber);
        this.currentEditFund.cost = this.calculateCost(
          this.currentEditFund.accountNumbers
        );
      } else {
        this.accountNumbersSelected.push(accountNumber);
        this.addingAccountNumbersMore = false;
      }
    },
    removeAccountNumber(accountNumber) {
      if (this.state === this.tabModes.editMode) {
        this.currentEditFund.accountNumbers = this.currentEditFund.accountNumbers.filter(
          (x) => x.purchaseOrderNumberId !== accountNumber.purchaseOrderNumberId
        );
        this.currentEditFund.cost = this.calculateCost(
          this.currentEditFund.accountNumbers
        );
      } else {
        this.accountNumbersSelected = rejectArray(
          this.accountNumbersSelected,
          (x) => x.purchaseOrderNumberId === accountNumber.purchaseOrderNumberId
        );
        if (this.accountNumbersSelected.length == 0) {
          this.addingCifras = false;
        }
      }
    },
    cancelAddingAccountNumber() {
      this.addingAccountNumbersMore = false;
      if (this.accountNumbersSelected.length == 0) {
        this.addingCifras = false;
      }
    },
    async saveHandler(skipToast = false) {
      let record = null;
      let isValid = await this.$refs.separationOfFunds.validate();

      if (!isValid) {
        this.ShowToast(
          'Alerta',
          'Favor completar la información para poder continuar.',
          'error'
        );
        return;
      }

      if (this.state === this.tabModes.editMode) {
        record = this.currentEditFund;

        if (record.accountNumbers.length == 0) {
          this.ShowToast(
            'Alerta',
            'Favor seleccione cifra de cuenta.',
            'error'
          );
          return;
        }
      } else {
        if (this.accountNumbersSelected.length == 0) {
          this.ShowToast(
            'Alerta',
            'Favor seleccione cifra de cuenta.',
            'error'
          );
          return;
        }

        const {
          contractType,
          date,
          contractDateTo,
          justification,
        } = this.record;
        const accountNumbers = [...this.accountNumbersSelected];
        record = {
          date,
          justification,
          contractDateTo,
          contractTypeId: contractType?.contractTypeId,
          cost: this.calculateCost(accountNumbers),
          accountNumbers: accountNumbers.map((accountNumber) => ({
            ...accountNumber,
            amount: Number(accountNumber.amount),
          })),
          proposalRequestId: this.proposalRequestId,
          contractId: this.contractId,
          academicYearId: this.academicYear.id,
          fiscalYearDescription: this.fiscalYearDescription,
        };
      }

      await (this.state === this.tabModes.editMode
        ? editSeparationFund(this.currentEditFund)
        : saveSeparationFund(record)
      )
        .then(() => {
          if (!skipToast) {
            this.ShowToast(
              'Alerta',
              'La asignación de fondos se ha completado exitosamente.',
              'success',
              5000
            );
          }

          this.changeState(tabModes.viewMode);
          this.initSeparation();
          this.$emit('refresh');
        })
        .catch((err) => {
          if (err.response != null)
            this.ShowToast(
              'Alerta',
              err.response.data.message || 'error',
              'error',
              5000
            );
        });
    },
    calculateCost(accountNumbers = []) {
      let result = 0;
      if (accountNumbers.length) {
        result = accountNumbers.reduce(
          (total, a) => total + Number(a.amount),
          0
        );
      }

      return result;
    },
    showAddingCifras(isEdit = false) {
      if (!isEdit) {
        if (this.record.contractDateTo == null) {
          this.ShowToast(
            'Alerta',
            'Favor añadir la fecha hasta para asignar los fondos.',
            'error',
            5000
          );
          return false;
        }
        this.addingCifras = true;
        this.addingAccountNumbersMore = true;
      } else {
        if (this.currentEditFund.contractDateTo == null) {
          this.ShowToast(
            'Alerta',
            'Favor añadir la fecha hasta para asignar los fondos.',
            'error',
            5000
          );
          return false;
        }
        this.addingCifras = true;
        this.addingAccountNumbersMore = true;
      }
    },
    removeAccountNumberUnSelected() {
      if (this.accountNumbersSelected.length > 0) {
        this.addingAccountNumbersMore = false;
      }
    },
    saveJustificationHandler(selection) {
      this.record.justification = selection[0]?.name;
    },
  },
};
</script>

<style scoped lang="scss">
@import '~@/shared/scss/config/fonts.scss';
@import '~@/shared/scss/config/colors.scss';

.separation-of-funds {
  .label {
    font-weight: normal;
    font-size: 0.875rem;
    color: map-get($colors, 'secondary-6');
  }

  .info {
    font-weight: normal;
    color: map-get($colors, 'black');
  }

  .separation-of-funds__separator ::v-deep {
    .separator-custom {
      --background-color-active: #b5c3bc;
      --line-separator-color: #b5c3bc;
      font-size: 0.875rem;
    }
  }
}
::v-deep(.dot) {
  padding: 15px 13px 15px 15px;
}
</style>
